import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "iconMore",
  "use": "iconMore-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"iconMore\"><g data-name=\"icon - more - 16px\" transform=\"translate(-1841 -966)\"><rect width=\"16\" height=\"16\" rx=\"8\" transform=\"translate(1841 966)\" fill=\"#031425\" /><g data-name=\"↳color\" fill=\"none\" stroke=\"#fff\" stroke-linecap=\"round\"><path data-name=\"Line 152\" d=\"M1849 971v6\" /><path data-name=\"Line 153\" d=\"M1846 974h6\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol